import React from 'react';
import PropTypes from 'prop-types';
import { Badge } from 'react-bootstrap';
import { useLocation, NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { lighten } from 'polished';
import {
  colorAccent,
  colorHover,
  colorText,
  sidebarColor,
  colorRed,
  colorGray,
} from '@/utils/palette';
import { 
  left,
  marginLeft,
  marginRight,
} from '@/utils/directions';

const SidebarLink = ({
  title, icon, newLink, route, onClick,
}) => {
  const location = useLocation();
  const currentUrl = location?.pathname;
  const parts = currentUrl.split('/');
  const firstPart = parts[1]; 

  return (
    <li>
      <SidebarNavLink
        to={route}
        onClick={onClick}
        activeClassName="active"
        className={
        (route === '/home' && firstPart === 'storedetailnew')
        || (route === '/homeproducts' && firstPart === 'productdetails')
          ? 'active'
          : ''
      }
      >
        {icon ? <SidebarLinkIcon className={`lnr lnr-${icon}`} /> : ''}
        <SidebarLinkTitle>
          {title}
          {newLink ? (
            <NewBadge bg="custom">
              <span>New</span>
            </NewBadge>
        ) : ''}
        </SidebarLinkTitle>
      </SidebarNavLink>
    </li>
  
  );
};

SidebarLink.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string,
  newLink: PropTypes.bool,
  route: PropTypes.string,
  onClick: PropTypes.func,
};

SidebarLink.defaultProps = {
  icon: '',
  newLink: false,
  route: '/',
  onClick: () => {},
};

export default SidebarLink;

// region STYLES

export const SidebarNavLink = styled(NavLink)`
  height: 40px;
  width: 240px;
  transition: all 0.2s ease;
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 10px 16px;
  margin: 2px 8px;
  overflow: hidden;
  background: transparent;
  border: none;
  border-radius: 10px;
  color: ${colorText};
  text-align: ${left};
  font-size: 14px;

  &.active {
    background: rgba(0, 247, 210, 0.15);
    border: 1px solid rgba(0, 247, 210, 0.3);

    &:before {
      opacity: 1;
    }
  }

  &:before {
    content: "";
    position: absolute;
    top: 0;
    height: 100%;
    width: 3px;
    background: linear-gradient(180deg, #5ce9ff, #00f7d2);
    opacity: 0;
    transition: all 0.2s ease;
    ${left}: 0;
    border-radius: 0 2px 2px 0;
  }

  &:hover {
    text-decoration: none;
    background-color: rgba(15, 23, 42, 0.6);
    color: ${colorText};
    transform: translateX(2px);

    &:before {
      opacity: 1;
    }
  }

  @media screen and (min-width: 576px) {
    width: 100%;
    margin: 2px 8px;

    span {
      position: relative;
      animation: none;
      ${left}: 0;
    }
  }
`;

const NewBadge = styled(Badge)`
  width: 26px;
  height: 14px;
  background-color: ${colorRed};
  font-size: 8px;
  font-weight: 400;
  padding: 2px;
  line-height: 9px;
  position: relative;
  text-transform: uppercase;
  border-radius: 7px;
  ${marginLeft}: 5px;

  span {
    position: absolute;
    top: 3px;
    width: 26px;
    text-align: center;
    ${left}: 0;
  }
`;

export const SidebarLinkTitle = styled.span`
  margin: 0;
  font-size: 13px;
  line-height: 1.4;
  position: relative;
  display: flex;
  align-items: center;
  white-space: nowrap;
  color: #e5e7eb;
  font-weight: 500;
  text-transform: none;
`;

export const SidebarLinkIcon = styled.span`
  font-size: 13px;
  line-height: 13px;
  color: ${lighten(0.25, colorGray)};
  ${marginRight}: 10px;
`;

// endregion
